// eslint-disable-next-line max-len

import { shortLanguages } from 'services/locale';

import mirageImg from './img/jacktop-mirage.webp';
import vaultImg from './img/jacktop-vip-vault.webp';

export const jacktopFrameUrl = `https://web.jacktop.win/init-game/?tokenAuth=<token>&clientId=<clientId>&gameId=<gameId>&lng=<lng>`;
export const jacktopClientId = 536;

export const jacktopImages: { [key: string]: string } = {
  119202: mirageImg,
  119102: vaultImg,
};

export const formatJacktopLink = (token: string, gameId: string | number, lang: string) =>
  jacktopFrameUrl
    .replace('<token>', token)
    .replace('<gameId>', gameId.toString())
    .replace('<clientId>', jacktopClientId.toString())
    .replace('<lng>', shortLanguages?.[lang as keyof typeof shortLanguages]);
